var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"echart"}},[_c('IEcharts',{staticClass:"echartPunchCard",attrs:{"loading":_vm.chart_loading,"option":_vm.options,"resizable":_vm.resizable,"auto-resize":_vm.autoresize}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }